import { render, staticRenderFns } from "./Horas.vue?vue&type=template&id=2bc02c16&"
import script from "./Horas.vue?vue&type=script&lang=js&"
export * from "./Horas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports